import styled from 'styled-components/macro'

export const BirthdaySelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-bottom: 15px;
`
